// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
function IconInfo(Props) {
  var classNameOpt = Props.className;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  return React.createElement("svg", {
    className: className,
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM216 336h24V272H216 192V224h24 48 24v24 88h8 24v48H296 216 192V336h24zm72-144H224V128h64v64z",
    fill: "currentColor"
  }));
}
IconInfo.displayName = "IconInfo";
var make = IconInfo;
export { make };
/* react Not a pure module */